/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4cdf3aa0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "preform-count-record"
};
var _hoisted_2 = {
  class: "preform-count-record-content"
};
var _hoisted_3 = {
  flex: ""
};
var _hoisted_4 = {
  style: {
    "margin-left": "15px"
  }
};
var _hoisted_5 = {
  style: {
    "width": "200px"
  }
};
var _hoisted_6 = {
  style: {
    "color": "var(--van-blue)"
  }
};
import { showToast } from 'vant';
import { EDateType } from '@/interface';
import Overlay from '@/components/Overlay.vue';
import { DEFAULT_PAGE } from '@/config/common';
import InfoCard from '@/views/components/InfoCard.vue';
import { readPreformSearchByTime } from '@/service/preform-count';
import DatePickerComprehensive from '@/components/DatePickerComprehensive/Index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Record',
  setup: function setup(__props) {
    var condition = ref('');
    var loading = ref(false);
    var finished = ref(false);
    var refreshing = ref(false);
    var showOverlay = ref(false);
    var timeType = ref(EDateType.day);
    var currentParams = reactive({
      startTime: _.stubString(),
      endTime: _.stubString()
    });
    var list = ref([]);
    var countInfo = reactive({
      totalRow: 0,
      freight: '',
      totalWeight: ''
    });
    var countInfoMap = reactive({
      totalRow: '总条数',
      freight: '总金额',
      totalWeight: '总重量'
    });
    var infoCardData = computed(function () {
      return _.map(countInfo, function (value, key) {
        return {
          value: value,
          label: countInfoMap[key]
        };
      });
    });
    var page = ref(DEFAULT_PAGE);
    var allParams = computed(function () {
      return _.assign({
        condition: condition.value
      }, page.value, currentParams);
    });
    function onUpdateSearch(value) {
      if (value) {
        list.value = [];
        onRefresh();
      }
    }
    function confrimDate(params) {
      console.log('confrimDate data=>', params);
      _.assign(currentParams, params);
      list.value = [];
      onRefresh();
    }
    function onLoad() {
      return _onLoad.apply(this, arguments);
    }
    function _onLoad() {
      _onLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (refreshing.value) {
                list.value = [];
                refreshing.value = false;
              }
              getPreformSearchByTime(allParams.value);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onLoad.apply(this, arguments);
    }
    function onRefresh() {
      resetPage();
      finished.value = false;
      loading.value = true;
      onLoad();
    }
    function getPreformSearchByTime(_x) {
      return _getPreformSearchByTime.apply(this, arguments);
    }
    function _getPreformSearchByTime() {
      _getPreformSearchByTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              showOverlay.value = true;
              _context2.next = 4;
              return readPreformSearchByTime(params);
            case 4:
              data = _context2.sent;
              list.value = _.concat(list.value, data.list);
              if (_.gt(data.totalPage, page.value.pageNumber)) {
                page.value.pageNumber += 1;
              }
              _.assign(countInfo, _.pick(data, ['totalRow', 'freight', 'totalWeight']));
              if (_.gte(_.size(list.value), countInfo.totalRow)) {
                finished.value = true;
              }
              _context2.next = 15;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              showToast(_context2.t0.message);
              finished.value = true;
            case 15:
              _context2.prev = 15;
              loading.value = false;
              showOverlay.value = false;
              return _context2.finish(15);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 11, 15, 19]]);
      }));
      return _getPreformSearchByTime.apply(this, arguments);
    }
    function resetPage() {
      page.value = _.clone(DEFAULT_PAGE);
    }
    return function (_ctx, _cache) {
      var _component_van_search = _resolveComponent("van-search");
      var _component_van_cell = _resolveComponent("van-cell");
      var _component_van_cell_group = _resolveComponent("van-cell-group");
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      var _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(DatePickerComprehensive, {
        showBtn: false,
        type: _unref(timeType),
        onConfirmDate: confrimDate
      }, {
        "bottom-extension": _withCtx(function () {
          return [_withDirectives(_createVNode(InfoCard, {
            size: "small",
            data: _unref(infoCardData)
          }, null, 8, ["data"]), [[_directive_loading, _unref(loading)]])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_van_search, {
            shape: "round",
            class: "search",
            modelValue: _unref(condition),
            "onUpdate:modelValue": [_cache[0] || (_cache[0] = function ($event) {
              return _isRef(condition) ? condition.value = $event : null;
            }), onUpdateSearch],
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入搜索关键词"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["type"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_pull_refresh, {
        modelValue: _unref(refreshing),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _isRef(refreshing) ? refreshing.value = $event : null;
        }),
        onRefresh: onRefresh,
        style: {
          "background": "none"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_list, {
            onLoad: onLoad,
            class: "list",
            offset: 50,
            finished: _unref(finished),
            loading: _unref(loading),
            "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
              return _isRef(loading) ? loading.value = $event : null;
            }),
            "finished-text": "没有更多了",
            "immediate-check": false
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), function (item) {
                return _openBlock(), _createBlock(_component_van_cell_group, {
                  key: item,
                  inset: "",
                  class: "cell-group"
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_van_cell, null, {
                      title: _withCtx(function () {
                        return [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, _toDisplayString(item.weight) + "吨", 1), _createElementVNode("h3", _hoisted_4, "￥" + _toDisplayString(item.freight), 1)])];
                      }),
                      label: _withCtx(function () {
                        return [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(item.create_time), 1), _createElementVNode("p", null, "车牌号：" + _toDisplayString(item.plate_number), 1), _createElementVNode("p", null, "始发地：" + _toDisplayString(item.from_warehouse_name), 1), _createElementVNode("p", null, "目的地：" + _toDisplayString(item.to_warehouse_name), 1)])];
                      }),
                      value: _withCtx(function () {
                        return [_createElementVNode("h3", _hoisted_6, _toDisplayString(item.stone_name), 1)];
                      }),
                      _: 2
                    }, 1024)];
                  }),
                  _: 2
                }, 1024);
              }), 128))];
            }),
            _: 1
          }, 8, ["finished", "loading"])];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(Overlay, {
        showOverlay: _unref(showOverlay)
      }, null, 8, ["showOverlay"])]);
    };
  }
});